import React from "react"
import QuickLink from "../../../BurgerQuickLink"
import {QUICKLINK_TYPE, BURGER_QUICKLINK_TYPE} from "../../../../config/constants"

export type CounrtySelectorProps = {
    title: string
    territory: string
    iconUrl: string
    isEnableCountrySelectorButton: boolean
    sub: string | null
    openDrawer: (isShowOverlay?: boolean) => void
    alteredTerritory: string
    currencyConfig: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const BurgerCountrySelector = ({
    title,
    territory,
    iconUrl,
    isEnableCountrySelectorButton,
    sub,
    openDrawer,
}: CounrtySelectorProps) => {
    const handleOnclick = () => {
        openDrawer(true)
    }

    if (!territory || !iconUrl || !isEnableCountrySelectorButton) return null
    const description = sub || undefined
    return (
        <QuickLink
            iconSrc={iconUrl}
            iconAltText={territory}
            iconFixedWidth={20}
            title={title}
            description={description}
            type={QUICKLINK_TYPE.BUTTON}
            handleClick={handleOnclick}
            linkType={BURGER_QUICKLINK_TYPE.COUNTRYSELECTOR}
        />
    )
}

export default BurgerCountrySelector
